import React, { FC, useEffect, useState } from "react";
import {
  FormChildQuestionDto,
  FormQuestionDto,
  SubmissionDataDto,
} from "@green0meter/api-client";
import { Divider } from "@mui/material";

import { useGetFormSectionSubmission } from "@api";
import { Stack, Typography } from "@components/base";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { useUserStore } from "@store/user";

interface PreviousSubmission {
  formId: string;
  sectionId: string;
  question: FormQuestionDto | FormChildQuestionDto;
}

const PreviousSubmission: FC<PreviousSubmission> = ({
  formId,
  sectionId,
  question,
}) => {
  const {
    selectedPreviousSubmissions,
    formSettings: { editMode },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { formSubmission, formSubmissionEnabled } = useGetFormSectionSubmission(
    user,
    { formId, sectionId },
    !editMode,
  );
  const [submissions, setSubmissions] = useState<SubmissionDataDto[]>([]);

  useEffect(() => {
    const questionSubmission = formSubmission?.find(
      // ts-expect-error TODO: fix this
      (submission) => submission.code === question.code,
    );

    setSubmissions(
      questionSubmission?.data?.filter((submission) =>
        selectedPreviousSubmissions.includes(submission.form.id),
      ) || [],
    );
  }, [formSubmission, selectedPreviousSubmissions, question]);

  return formSubmissionEnabled && submissions.length > 0 ? (
    <Stack spacing={2} mt={2}>
      <Divider />
      {submissions.map((submission) => (
        <Typography key={`submission-${submission.form.id}`} color="textSecondary">
          {/* TODO: fix submission.value should be string not object */}
          {/* eslint-disable-next-line react/jsx-no-literals */}
          {submission.form.name}: {submission.value?.toString()}
        </Typography>
      ))}
    </Stack>
  ) : null;
};

export default PreviousSubmission;
